import { render, staticRenderFns } from "./myChatList.vue?vue&type=template&id=8b3ec65a&scoped=true"
import script from "./myChatList.vue?vue&type=script&lang=js"
export * from "./myChatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3ec65a",
  null
  
)

export default component.exports